import { GeoJsonLayer } from "@deck.gl/layers";

import type { LabelGeoJSON, PinnedLocation } from "~/lib/map/types";
import { geoJsonsToCharacterSet } from "./geoJsonsToCharacterSet";
import { locationToLabelGeoJson } from "./locationToLabelGeoJson";

export const initPinnedLocationsLayer = (pinnedLocations: PinnedLocation[]) => {
  const labelGeoJsons = pinnedLocations.filter((l) => l.isShow).map((location) => locationToLabelGeoJson(location));

  return new GeoJsonLayer({
    id: "pinned-locations-layer",
    data: labelGeoJsons,
    stroked: true,
    filled: true,
    pointType: "circle+text",

    // point and line
    getLineWidth: 3,
    lineWidthUnits: "pixels",
    getPointRadius: 5,
    pointRadiusUnits: "pixels",
    getFillColor: [200, 0, 0, 200],
    getLineColor: [255, 255, 255, 200],

    // text
    getTextColor: [200, 0, 0],
    // A location without a label is drawn as the dot alone; without this the empty text still paints its
    // padded background box.
    getTextBackgroundColor: (d: LabelGeoJSON) => (d.properties.label ? [255, 255, 255, 180] : [0, 0, 0, 0]),
    getText: (d: LabelGeoJSON) => d.properties.label ?? null,
    textFontFamily: "system-ui,SFMono-Regular,Menlo,Monaco,Consolas,monospace",
    getTextSize: 16,
    textSizeScale: 0.6,
    textFontWeight: 600,
    textLineHeight: 1,
    textBackground: true,
    textBackgroundPadding: [6, 4],
    getTextPixelOffset: [0, -18],
    textCharacterSet: geoJsonsToCharacterSet(labelGeoJsons),
  });
};
